import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Card } from "./card";
import { useMediaQuery } from "react-responsive";
const cardsData = [
  {
    icon: "/assets/images/keinternational/chart.svg",
    headline: "ROAS from Meta is down to 2–4X",
    cta: "You’re paying more and getting less. Meta just isn’t scaling like it used to.",

  },
  {
    icon: "/assets/images/keinternational/mail.svg",
    headline: "Email & SMS open rates are <10%",
    cta: "Most of your emails don’t even get opened, let alone clicked.",

  },
  {
    icon: "/assets/images/keinternational/coin.svg",
    headline: "Retargeting is as expensive as acquisition",
    cta: "Running RT campaigns now costs as much as acquiring new customers.",
  },

];



const image = [
  {
    icon: "/assets/images/keinternational/ape.svg",
  },
  {
    icon: "/assets/images/keinternational/natur.svg",
  },
  {
    icon: "/assets/images/keinternational/belle.svg",
  },
  {
    icon: "/assets/images/keinternational/studio.svg",
  },
  {
    icon: "/assets/images/keinternational/rippl.svg",
  },

];

export const SectionTwo = () => {
  const scrollToTop = () => {
    const isMobileOrTablet = window.innerWidth <= 991;
    window.scrollTo({
      top: isMobileOrTablet ? 350 : 100,
      behavior: "smooth",
    });
  };

  const isMobile = useMediaQuery({ maxWidth: 768 });

  return (
    <div className="section-2a">
      <div className="container-fluid">
        <div className="top-text">
          <h1>Powering 100+ ambitious D2C brands across the UK</h1>

        </div>
        <div
          className="d-flex flex-wrap justify-content-center align-items-center"
          style={{ margin: "50px 0 80px 0", gap: !isMobile ? "150px" : "60px" }}
        >
          {image.map((data, ind) => {
            const isStudio = data.icon.includes("studio.svg");
            const isNautur = data.icon.includes("natur.svg");
            const isLarge = isStudio || isNautur;
            return (
              <div
                key={ind}
                style={{
                  maxWidth: isLarge ? "150px" : "100px", // Increased width for studio
                  minWidth: isLarge ? "80px" : "60px",
                  color: "white",
                }}
              >
                <img
                  src={data.icon}
                  alt={`Brand ${ind}`}
                  style={{
                    width: "100%",
                    height: "auto",
                    objectFit: "contain",
                  }}
                />
              </div>
            );
          })}
        </div>


        <hr style={{ border: "2px solid #1b252b" }} />

        <div className="mid-text">
          <h1>The Typical Retention Playbook <br /> Doesn’t Work Anymore</h1>
        </div>
      </div>
      <div className="cards-container">
        {cardsData.map((data, index) => (
          <Card data={data} key={index} />
        ))}
      </div>

    </div>
  );
};
